var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.siteId == 116)?_c('CourseListWtxh'):_c('CourseListDefault')
}
var staticRenderFns = []

export { render, staticRenderFns }